<template>
    <jet-action-section>
        <template #title>
            Restart Site Tutorial
        </template>
        <template #description>
            You can restart the tutorial for demo purposes here. Make sure you have a Double boost and an unentered meeting for Tommorow. (ADMINS ONLY)
        </template>
        <template #content>
            <div class="inflex items-center">
                <jet-button v-if="restartClicked === false && user.tutorial_step === 0" type="button" @click="resetTutorialStep(); restartClicked=true">
                    Restart Tutorial
                </jet-button>

                <div v-else-if="restartClicked === true && user.tutorial_step === 1">
                    <p class="text-sm text-gray-600 transition duration-500 ease-in-out dark:text-white">Tutorial reset, return to dashboard to start tutorial over again.</p>
                </div>
                <div v-else-if="skipClicked === false">
                    <p class="text-sm text-gray-600 transition duration-500 ease-in-out dark:text-white mb-3">You are currently in the middle of a tutorial, please complete or skip this tutorial first.</p>
                                    
                    <jet-button type="button" @click="setTutorialStep(0); skipClicked=true">
                        Force Skip Tutorial
                    </jet-button>
                </div>
            </div>
        </template>
    </jet-action-section>
</template>
<script>
import JetActionSection from '@/Jetstream/ActionSection.vue'
import JetButton from '@/Jetstream/Button.vue'
import JetConfirmsPassword from '@/Jetstream/ConfirmsPassword.vue'
import JetDangerButton from '@/Jetstream/DangerButton.vue'
import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue'

export default {
    components: {
        JetActionSection,
        JetButton,
        JetConfirmsPassword,
        JetDangerButton,
        JetSecondaryButton,
    },

    data() {
        return {

        }
    },

    methods: {

    },

    props: ['user'],

    props: {
        user: {
            type: Object,
        },

        restartClicked: {
            type : Boolean,
            default : false,
        },
        skipClicked: {
            type : Boolean,
            default : false,
        },
    },

    setup(props) {

        const setTutorialStep = (tutorialStep) => {

            if (props.user.tutorial_step > 0) {
            props.user.tutorial_step = tutorialStep 

            axios.post(route('api.tutorial.set'), {
                tutorialStep: tutorialStep
            })
            
            }
        }

        const resetTutorialStep = () => {
            // Stops the user from resetting the tutorial mid-tutorial causing sequential XP reductions
            if (props.user.tutorial_step === 0) {
                
                props.user.tutorial_step = 1 

                // axios.post(route('api.tutorial.set'), {
                //     tutorialStep: props.user.tutorial_step
                // })
            }
        }

        return {
            resetTutorialStep,
            setTutorialStep,
        }
    }
}

</script>
